import { onDeleteError, onFormError, onActionError } from '../../core/utils/hooks'
import { notification } from 'antd'

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  fetchWithPagination,
  toggle,
  remove,
  load,
  create,
  update
} from '../../api/manager/project'

import { key as cacheKey } from '../cache/client'

const key = 'manager.project'

export const useList = (queryParams) => {
  return useQuery({
    queryKey: [key, queryParams],
    queryFn: () => fetchWithPagination(queryParams)
  })
}

export const useFetch = (id) => {
  return useQuery({
    queryKey: [key, id],
    queryFn: () => load(id)
  })
}

export const useToggle = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: toggle,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])
      queryClient.invalidateQueries([cacheKey])

      notification.success({
        message: 'Updated',
        description: 'The project was updated'
      })
    },
    onError: onActionError
  })
}

export const useRemove = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: remove,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])
      queryClient.invalidateQueries([cacheKey])

      notification.success({
        message: 'Deleted',
        description: 'The project was deleted'
      })
    },
    onError: onDeleteError
  })
}

export const usePostForm = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: create,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key])
      queryClient.invalidateQueries([cacheKey])

      notification.success({
        message: 'Created',
        description: 'The project was created'
      })
    },
    onError: onFormError
  })
}

export const usePutForm = (id) => {
  const queryClient = useQueryClient()
  const action = (form) => update(id, form)
  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries([key, id])
      queryClient.invalidateQueries([cacheKey])

      notification.success({
        message: 'Updated',
        description: 'The project was updated'
      })
    },
    onError: onFormError
  })
}
